import {
    TOGGLE_FINANCIAL_TARGET_GRID,
    UPDATE_COLLAPSE_MODE,
    UPDATE_DISPLAYED_ROWS,
    UPDATE_SELECTED_TARGET_IDS,
} from "actions/financial-target/action-types";
import { handleActions } from "redux-actions";
import {
    toggleFinancialTargetGrid,
    updateDisplayedGridRows,
    updateSelectedTargetIds,
    updateCollapseMode,
} from "./action-handlers";
import { getInitialState } from "./initial-state";
import { FinancialTargetReduxState } from "./types";

export const financialTarget = handleActions<FinancialTargetReduxState>(
    {
        [TOGGLE_FINANCIAL_TARGET_GRID]: toggleFinancialTargetGrid,
        [UPDATE_SELECTED_TARGET_IDS]: updateSelectedTargetIds,
        [UPDATE_DISPLAYED_ROWS]: updateDisplayedGridRows,
        [UPDATE_COLLAPSE_MODE]: updateCollapseMode,
    } as any,
    getInitialState(),
);
